import { render, staticRenderFns } from "./detail-i-fenshen.vue?vue&type=template&id=04e24ad6"
import script from "./detail-i-fenshen.vue?vue&type=script&lang=js"
export * from "./detail-i-fenshen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports